export const RQ_GET_PROFILE_API = {
  url: 'api/user/lookup/all/users/<%= id %>',
  method: 'GET',
  auth: true,
};
